import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icon/amway-cc-logo-b.svg'
import _imports_1 from '@/assets/icon/icon-people.svg'
import _imports_2 from '@/assets/icon/icon-edit-profile.svg'
import _imports_3 from '@/assets/icon/icon-back-to.svg'
import _imports_4 from '@/assets/icon/icon-back.svg'
import _imports_5 from '@/assets/icon/icon-error.svg'
import _imports_6 from '@/assets/icon/icon-female.svg'
import _imports_7 from '@/assets/icon/icon-male.svg'
import _imports_8 from '@/assets/icon/icon-success.svg'
import _imports_9 from '@/assets/icon/icon-save.svg'


const _hoisted_1 = { class: "profile" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "header-area" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Amway Creator Challenge"
}, null, -1)
const _hoisted_5 = { class: "profile-area" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  class: "profile-info",
  id: "profile-info"
}
const _hoisted_8 = { class: "profile-info-area" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_10 = { class: "profile-info-name" }
const _hoisted_11 = { class: "profile-info-id" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("โปรไฟล์ของฉัน")
const _hoisted_14 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.amway.co.th",
  class: "link-red"
}, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }),
  /*#__PURE__*/_createTextVNode("กลับไปยังเว็บไซต์หลัก")
], -1)
const _hoisted_15 = { class: "container-full" }
const _hoisted_16 = { class: "back-button" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" กลับ ")
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = { class: "profile-content" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h4", null, "โปรไฟล์ของฉัน", -1)
const _hoisted_22 = { class: "profile-thumbnail" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "form-title-section" }, [
  /*#__PURE__*/_createElementVNode("span", null, "1."),
  /*#__PURE__*/_createTextVNode("ข้อมูลผู้สมัคร")
], -1)
const _hoisted_24 = { class: "form-profile row" }
const _hoisted_25 = { class: "mt-10 col-lg-6" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { for: "abo-id" }, [
  /*#__PURE__*/_createTextVNode("รหัสนักธุรกิจแอมเวย์ "),
  /*#__PURE__*/_createElementVNode("span", null, "*")
], -1)
const _hoisted_27 = ["value"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", {
  class: "input-error-text alert-error",
  id: "abo-id-alert"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    class: "icon-error"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "กรอกข้อมูลไม่ถูกต้อง")
], -1)
const _hoisted_29 = { class: "col-lg-6 mt-10" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, [
  /*#__PURE__*/_createTextVNode("ชื่อ - นามสกุล "),
  /*#__PURE__*/_createElementVNode("span", null, "*")
], -1)
const _hoisted_31 = ["value"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", {
  class: "input-error-text alert-error",
  id: "name-alert"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    class: "icon-error"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "กรอกข้อมูลไม่ถูกต้อง")
], -1)
const _hoisted_33 = { class: "form-profile row" }
const _hoisted_34 = { class: "col-lg-6 mt-21" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { for: "age" }, [
  /*#__PURE__*/_createTextVNode("อายุ "),
  /*#__PURE__*/_createElementVNode("span", null, "*")
], -1)
const _hoisted_36 = ["value"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", {
  class: "input-error-text alert-error",
  id: "age-alert"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    class: "icon-error"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "กรอกข้อมูลไม่ถูกต้อง")
], -1)
const _hoisted_38 = { class: "col-lg-6 mt-21" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { for: "gender" }, [
  /*#__PURE__*/_createTextVNode("เพศ "),
  /*#__PURE__*/_createElementVNode("span", null, "*")
], -1)
const _hoisted_40 = { class: "custom-radio" }
const _hoisted_41 = ["checked"]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", {
  for: "male",
  class: "custom-radio-label",
  style: {"padding":"8px","border":"none","box-shadow":"none"}
}, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }),
    /*#__PURE__*/_createTextVNode(" ชาย")
  ])
], -1)
const _hoisted_43 = ["checked"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", {
  for: "female",
  class: "custom-radio-label",
  style: {"padding":"8px","border":"none","box-shadow":"none"}
}, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_7 }),
    /*#__PURE__*/_createTextVNode(" หญิง")
  ])
], -1)
const _hoisted_45 = { class: "form-profile row" }
const _hoisted_46 = { class: "col-lg-12 mt-21" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", { for: "platform" }, [
  /*#__PURE__*/_createTextVNode("แพลตฟอร์ม ร่วมกิจกรรม "),
  /*#__PURE__*/_createElementVNode("span", null, "*")
], -1)
const _hoisted_48 = { class: "search-link" }
const _hoisted_49 = ["value"]
const _hoisted_50 = /*#__PURE__*/_createStaticVNode("<div class=\"input-error-text alert-error\" id=\"link-alert\"><img src=\"" + _imports_5 + "\" class=\"icon-error\"><span class=\"text-danger\">กรอกข้อมูลไม่ถูกต้อง</span></div><div class=\"alert-success d-none\" id=\"alert-success\"><img src=\"" + _imports_8 + "\" class=\"icon-success-input\"><img src=\"" + _imports_8 + "\" class=\"icon-error\"><span class=\"text-green\">ลิงก์นี้สามารถใช้งานได้</span></div>", 2)
const _hoisted_52 = { class: "row" }
const _hoisted_53 = { class: "col-lg-12 mt-21" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", { for: "platform" }, [
  /*#__PURE__*/_createTextVNode("Facebook Profile ส่วนตัวของคุณที่ใช้เข้าร่วมกลุ่ม รวมพลคน Fit Firm Fun และ Creators Thailand Community "),
  /*#__PURE__*/_createElementVNode("span", null, "*")
], -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", {
  class: "input-error-text alert-error",
  id: "social-alert"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    class: "icon-error"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "กรอกข้อมูลไม่ถูกต้อง")
], -1)
const _hoisted_56 = { class: "control-button" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_9,
    style: {"width":"32px","height":"32px","margin-right":"12px"}
  }),
  /*#__PURE__*/_createTextVNode("บันทึก ")
], -1)
const _hoisted_58 = [
  _hoisted_57
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: _ctx.dayjs().isSameOrAfter('2022-03-05') ? '/activity' : '/challenge',
          class: "header-logo"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["to"]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "profile-icon",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showProfileInfo()))
          }, [
            _createElementVNode("img", {
              src: _ctx.$store.state.userInfo.profile_image ? _ctx.$store.state.userInfo.profile_image : require('@/assets/images/landing/people.svg')
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$store.state.userInfo.name), 1),
                _createElementVNode("div", _hoisted_11, " รหัสนักธุรกิจแอมเวย์ " + _toDisplayString(_ctx.$store.state.userInfo.abo_id), 1)
              ])
            ]),
            _createVNode(_component_router_link, {
              to: "/profile",
              class: "link-black"
            }, {
              default: _withCtx(() => [
                _hoisted_12,
                _hoisted_13
              ]),
              _: 1
            }),
            _hoisted_14
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("a", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.go(-1))),
          class: "btn-back"
        }, _hoisted_19)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", {
            class: "profile-thumbnail-img",
            style: _normalizeStyle({
              backgroundImage: `url('${_ctx.$store.state.userInfo.profile_image ? _ctx.$store.state.userInfo.profile_image : require('@/assets/images/landing/people.svg')}')`,
            })
          }, null, 4)
        ]),
        _hoisted_23,
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("input", {
              type: "text",
              name: "abo-id",
              id: "abo-id",
              value: _ctx.$store.state.userInfo.abo_id,
              placeholder: "กรอกรหัสนักธุรกิจแอมเวย์ของคุณ",
              readonly: "readonly",
              disabled: ""
            }, null, 8, _hoisted_27),
            _hoisted_28
          ]),
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("input", {
              type: "text",
              name: "name",
              id: "name",
              placeholder: "กรอกชื่อ - นามสกุลของคุณ",
              readonly: "readonly",
              value: _ctx.$store.state.userInfo.name,
              disabled: ""
            }, null, 8, _hoisted_31),
            _hoisted_32
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _createElementVNode("input", {
              type: "text",
              name: "age",
              id: "age",
              readonly: "readonly",
              placeholder: "กรอกอายุของคุณ",
              value: _ctx.$store.state.userInfo.age,
              disabled: ""
            }, null, 8, _hoisted_36),
            _hoisted_37
          ]),
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", {
                class: _normalizeClass(`custom-radio-active ${_ctx.$store.state.userInfo.gender.toLowerCase() == 'male' ? 'active-01' : 'active-02'}`)
              }, null, 2),
              _createElementVNode("div", {
                class: "custom-radio-choice",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.choiceActive($event, '02', '01')))
              }, [
                _createElementVNode("input", {
                  type: "radio",
                  name: "gender",
                  id: "male",
                  readonly: "readonly",
                  value: "male",
                  checked: 
                    _ctx.$store.state.userInfo.gender.toLowerCase() == 'male'
                  ,
                  disabled: ""
                }, null, 8, _hoisted_41),
                _hoisted_42
              ]),
              _createElementVNode("div", {
                class: "custom-radio-choice",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.choiceActive($event, '01', '02')))
              }, [
                _createElementVNode("input", {
                  type: "radio",
                  name: "gender",
                  id: "female",
                  readonly: "readonly",
                  value: "female",
                  checked: 
                    _ctx.$store.state.userInfo.gender.toLowerCase() == 'female'
                  ,
                  disabled: ""
                }, null, 8, _hoisted_43),
                _hoisted_44
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _hoisted_47,
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("input", {
                type: "text",
                name: "platform-link",
                id: "platform-link",
                value: _ctx.$store.state.userInfo.social_media,
                placeholder: "URL Link",
                disabled: ""
              }, null, 8, _hoisted_49),
              _hoisted_50
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_52, [
          _createElementVNode("div", _hoisted_53, [
            _hoisted_54,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "name",
              id: "name",
              placeholder: "URL Link",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.socialURL) = $event)),
              required: "",
              disabled: ""
            }, null, 512), [
              [
                _vModelText,
                _ctx.socialURL,
                void 0,
                { trim: true }
              ]
            ]),
            _hoisted_55
          ])
        ]),
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("button", {
            type: "button",
            class: "btn-red no-fix mt-16",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.submit($event)))
          }, _hoisted_58)
        ])
      ])
    ])
  ]))
}